<template>
  <v-content>
    <v-container
      fill-height
      fluid>
      <v-layout
        align-center
        justify-center>
        <v-flex
          xs12
          sm8
          md4>
          <v-card
            style="color: rgb(75, 85, 99); padding: 20px"
            class="elevation-12">
            <div style="width: 100px; margin: 0 auto;">
              <v-img src="/img/logo.png"/>
            </div>
            <br>
            <v-card-text>
              <p>Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.</p>
              <p
                v-if="sent"
                style="color:rgb(5, 122, 85);">We have emailed your password reset link!</p>
            </v-card-text>
            <v-card-text>
              <v-text-field
                ref="email"
                v-model="email"
                :rules="[() => !!email|| 'This field is required']"
                prepend-icon="mdi-account"
                label="Email"
                placeholder="Your email address"
                counter
                required
                @keydown.enter="sendEmail"
              />

            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                align-center
                justify-center
                color="general"
                @click="sendEmail">EMAIL PASSWORD RESET LINK
              </v-btn>
            </v-card-actions>
            <v-snackbar
              v-model="snackbar"
              :color="color"
              :top="true"
            >
              {{ errorMessages }}
              <v-btn
                dark
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>
          </v-card>
        </v-flex>
      </v-layout>

    </v-container>
  </v-content>
</template>

<script>
  import axios from 'axios'

  export default {
    data: function () {
      return {
        email: '',
        errorMessages: 'User does not exist',
        snackbar: false,
        color: 'general',
        sent: false
      }
    },

    // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
    methods: {
      sendEmail: function () {
        console.log('inside of send email')
        let email = this.email
        if (email === '') {
          this.errorMessages = 'Email is required'
          this.snackbar = true
        }
        axios.post('/api/password-reset', { email: email })
                .then(response => {
                  console.log(response.data)
                  this.sent = true
                })
                .catch(err => {
                  console.log(err)
                  console.log(err.response.status)
                  if (err.response.status === 422) {
                    this.errorMessages = err.response.data.errors
                    this.snackbar = true
                  }
                })
      }
    },
    metaInfo () {
      return {
        title: 'Password Reset'
      }
    }
  }
</script>
